import PromineoEditActionColumnButton from "components/common/PromineoEditActionColumnButton";
import PromineoDeleteActionColumnButton from "components/common/PromineoDeleteActionColumnButton";

interface Props {
  onEditClick: () => void;
  onDeleteClick: () => void;
}

export default function ManageUserGridActions(props: Props) {
  const { onEditClick, onDeleteClick } = props;

  return (
    <>
      <div className="space-x-3">
        <PromineoEditActionColumnButton
          editClicked={onEditClick}
        />
        <PromineoDeleteActionColumnButton
          deleteClicked={onDeleteClick}
        />
      </div>
    </>
  );
}
